document.addEventListener("DOMContentLoaded", function () {
  const accessToken = "pk.eyJ1IjoiYW5kcmV3bGFuZXNoYXJrIiwiYSI6ImNsNnh1amFvbDJvenEza29ka3p6ajZwd3gifQ.dOm4A63LvIWJQiDcJd7XSQ";

  // HH4 (Hammerhead) is the only product where the native variant selector / Add to Cart
  // stay hidden - everything is routed through dealer results or the FloDesk form instead.
  // All other products (LS-2/3/4) show their normal variant selection and Add to Cart.
  const isHammerheadPage = window.location.href.toUpperCase().includes("HAMMERHEAD");
  if (isHammerheadPage) {
    const initialAtcBlock = document.querySelector(".product-form__buttons");
    if (initialAtcBlock) {
      initialAtcBlock.style.display = "none";
    }
  }

  // Per-product toggle for the "no dealer in range" fallback: true shows the
  // tractor-compatibility confirmation box, which then reveals the normal Add
  // to Cart button (a direct online purchase path); false shows the FloDesk
  // signup form + nearest in-stock dealer instead (no direct purchase path).
  // Flip a product's value here to change its behavior.
  const showCompatibilityConfirmationByProduct = {
    ls2: true,
    ls3: true,
    ls4: true,
    hh4: true
  };

const stateShippingRates = {
  "West": ["CA", "OR", "WA", "NV", "AZ", "UT", "ID", "MT", "WY", "NM"],
  "Midwest": ["ND", "SD", "NE", "KS", "MN", "IA", "MO", "WI", "IL", "IN", "MI", "OH"],
  "South": ["TX", "OK", "AR", "LA", "KY", "TN", "MS", "AL", "GA", "FL", "SC", "NC", "VA", "WV"],
  "Northeast": ["PA", "NY", "NJ", "CT", "RI", "MA", "VT", "NH", "ME", "MD", "DE"],
  "Alaska": ["AK"],
  "Hawaii": ["HI"]
};

const regionShippingPrices = {
  "West": 850,
  "Midwest": 600,
  "South": 500,
  "Northeast": 600,
  "Alaska": 1900,
  "Hawaii": 1800
};

function getShippingEstimateByState(stateAbbr) {
  for (const region in stateShippingRates) {
    if (stateShippingRates[region].includes(stateAbbr)) {
      const basePrice = regionShippingPrices[region];
      const margin = basePrice * 0.03;
      const randomOffset = (Math.random() * margin * 2) - margin; // random between -3% and +3%
      return Math.round(basePrice + randomOffset);
    }
  }
  return null; // Unknown state
}
  
  document.getElementById("dealerSearchBtn").addEventListener("click", async function () {
    const atcBlock = document.querySelector(".product-form__buttons");
    if (atcBlock) {
      atcBlock.style.display = "none"; // Hide ATC button at start of each search
    }
    const confirmationBoxReset = document.getElementById("atcConfirmationBox");
    if (confirmationBoxReset) {
      confirmationBoxReset.classList.add("hidden"); // Hide compatibility confirmation box at start of each search
    }
    const flodeskBoxReset = document.getElementById("flodeskFormBox");
    if (flodeskBoxReset) {
      flodeskBoxReset.classList.add("hidden"); // Hide FloDesk form at start of each search
    }
    const canadianNoticeReset = document.getElementById("canadianNotice");
    if (canadianNoticeReset) {
      canadianNoticeReset.classList.add("hidden"); // Hide Canada notice at start of each search
    }
    const resultsBottomReset = document.getElementById("dealerResultsBottom");
    if (resultsBottomReset) {
      resultsBottomReset.innerHTML = ""; // Clear dealer/nearest-in-stock cards at start of each search
    }

    const zip = document.getElementById("zipInput").value.trim();
    if (!zip) {
      alert("Please enter a valid zip code");
      return;
    }

   let zipInfoResponse = await fetch(`https://secure.geonames.org/postalCodeLookupJSON?postalcode=${zip}&country=US&username=laneshark`);
if (!zipInfoResponse.ok) {
  // If US fails, try Canadian zip lookup
  const intlResponse = await fetch(`https://secure.geonames.org/postalCodeLookupJSON?postalcode=${zip}&country=CA&username=laneshark`);
  if (!intlResponse.ok) {
    alert("Invalid or unsupported ZIP/Postal code.");
    return;
  } else {
    const intlData = await intlResponse.json();
    const notice = document.getElementById("canadianNotice");
    if (notice) {
      notice.classList.remove("hidden");
    }
    return;
  }
}

// If US zip lookup succeeded
const zipInfo = await zipInfoResponse.json();
const place = zipInfo.postalcodes[0];
const city = place.placeName;
const state = place.adminCode1;
const country = zipInfo.country;
// Optional: Show ZIP code location feedback
const zipFeedback = document.getElementById("zipLocationFeedback");
if (zipFeedback) {
  zipFeedback.innerText = `${city}, ${state}`;
}

    try {
const geocodeResponse = await fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${zip}.json?access_token=${accessToken}&country=US,CA`);
      if (!geocodeResponse.ok) throw new Error(`Geocode API Error: ${geocodeResponse.statusText}`);
      const geocodeData = await geocodeResponse.json();

      if (!geocodeData.features.length) {
        alert("Invalid Zip Code");
        return;
      }

      const [userLng, userLat] = geocodeData.features[0].center;

      const dealerResponse = await fetch("https://portal.lanesharkusa.com/api/public/dealers");
      if (!dealerResponse.ok) throw new Error(`Dealer API Error: ${dealerResponse.statusText}`);
      const dealers = await dealerResponse.json();

      if (!Array.isArray(dealers) || dealers.length === 0) {
        alert("No dealership data found.");
        return;
      }

      if (typeof turf === "undefined") {
        alert("Error: Turf.js library is missing.");
        return;
      }
 const url = window.location.href.toUpperCase();
  let fallbackPrice = "";
  let  dealerPrice = "";
  let stockField = "ls2Stock";
  let productKey = "ls2";

  if (url.includes("LS-4")) {
    fallbackPrice = `5600`;
    dealerPrice = `5100`;
    stockField = "ls4Stock";
    productKey = "ls4";
  } else if (url.includes("LS-3")) {
    fallbackPrice = `5400`;
    dealerPrice = `4900`;
    stockField = "ls3Stock";
    productKey = "ls3";
  } else if (url.includes("HAMMERHEAD")) {
    fallbackPrice = `10490`;
    dealerPrice = `9990`;
    stockField = "hh4Stock";
    productKey = "hh4";
  } else {
    fallbackPrice = "Unavailable";
  }

  const showCompatibilityConfirmation = showCompatibilityConfirmationByProduct[productKey] ?? false;
      
      const dealersWithDistance = dealers
        .map(dealer => {
          if (!dealer.lat || !dealer.lng) return null;
          const distance = turf.distance(
            turf.point([userLng, userLat]),
            turf.point([dealer.lng, dealer.lat]),
            { units: "miles" }
          );
          return { ...dealer, distance };
        })
        .filter(dealer => dealer !== null)
        .sort((a, b) => a.distance - b.distance);

      const nearbyDealers = dealersWithDistance.filter(dealer => dealer.distance <= 40); //Adjust distance here

      const hasStock = dealer => typeof dealer[stockField] === "number" && dealer[stockField] > 0;

      const renderDealerCard = (dealer, { highlight = false, label = "" } = {}) => {
        const stockValue = dealer[stockField];
        const inStock = hasStock(dealer);
        const stockLabel = inStock ? `${stockValue} in stock` : "Sold Out";
        const stockClass = inStock ? "in-stock" : "sold-out";
        return `
          <div class="dealer-card${highlight ? " dealer-card-highlight" : ""}">
            ${label ? `<div class="dealer-card-label">${label}</div>` : ""}
            <strong>${dealer.title}</strong><br>
            ${dealer.city}, ${dealer.state} - ${dealer.distance.toFixed(1)} miles away<br>
            <span class="dealer-stock ${stockClass}">${stockLabel}</span><br>
            <a
              href="https://lanesharkusa.com/pages/dealer-locator?dealer=${dealer.id}&lat=${dealer.lat}&lng=${dealer.lng}"
              target="_blank"
              style="color: #0056b3;"
            >
              View on Map<span class="visually-hidden"> for ${dealer.title} (opens in a new tab)</span>
            </a>
          </div>
        `;
      };

      // Price/info block renders in the top results slot; individual dealer
      // cards (and the FloDesk form, which sits between the two in the DOM)
      // render below it - see dealerResultsTop / flodeskFormBox / dealerResultsBottom.
      const resultsTop = document.getElementById("dealerResultsTop");
      const resultsBottom = document.getElementById("dealerResultsBottom");
      resultsTop.innerHTML = `<h2 style="margin-bottom: 5px;">$${dealerPrice}</h2><em style="font-size: 1.25rem;">Price does not include shipping, taxes, or installation.</em>`;
      resultsBottom.innerHTML = "";

  if (nearbyDealers.length === 0) {
  const flodeskBox = document.getElementById("flodeskFormBox");
  const confirmationBox = document.getElementById("atcConfirmationBox");
  const atcBlock = document.querySelector(".product-form__buttons");

  // No dealer in range - keep the native Add to Cart button hidden until/unless
  // explicitly revealed below (only happens for products with the compatibility
  // confirmation enabled, once the buyer confirms).
  if (atcBlock) {
    atcBlock.style.display = "none";
  }

  const estimatedShipping = getShippingEstimateByState(state);
console.log("ZIP State:", state);
console.log("Shipping Estimate:", getShippingEstimateByState(state));
  let shippingString = estimatedShipping
    ? ` + <sup>$</sup>${estimatedShipping.toLocaleString()} <em style="font-size: 1.25rem;">est freight</em>`
    : "";

  // HH4 pricing varies by package, so the no-dealer view shows it as a starting price
  // (no package selector).
  const packageNote = isHammerheadPage
    ? `<em style="font-size: 1.25rem;">starting price - actual price depends on package selected</em><br/>`
    : "";

  resultsTop.innerHTML = `
    <div style="margin-top: 10px;">
      <h4 style="margin: 0px;">Online Retail Price</h4>
      <h2 style="margin-bottom: 5px;">
        <sup>$</sup>${fallbackPrice}${shippingString}
      </h2>
      ${packageNote}
      <em style="font-size: 1.25rem;">price does not include taxes or installation</em><br/>
      <em style="font-size: 1.25rem;">freight is door-to-door residential with lift gate</em>
    </div>
  `;

  if (showCompatibilityConfirmation) {
    // This product still allows a direct online purchase when no dealer is in
    // range, once the buyer confirms tractor compatibility.
    if (confirmationBox) {
      confirmationBox.classList.remove("hidden");
    }

    const confirmBtn = document.getElementById("confirmCompatibility");
    if (confirmBtn && !confirmBtn.dataset.boundConfirm) {
      confirmBtn.dataset.boundConfirm = "true";
      confirmBtn.addEventListener("click", function () {
        if (confirmationBox) confirmationBox.classList.add("hidden");
        const atcBlockToShow = document.querySelector(".product-form__buttons");
        if (atcBlockToShow) atcBlockToShow.style.display = "block";
        const atcVariant = document.querySelector(".product-form_radios");
        if (atcVariant) atcVariant.style.display = "block";
      });
    }
  } else {
    // No direct purchase path for this product - route to the FloDesk form +
    // nearest in-stock dealer instead.
    if (flodeskBox) {
      flodeskBox.classList.remove("hidden");
    }

    // Search the full dealer list (not just the 40-mile radius) for the nearest
    // dealer that actually has stock, and show it below the FloDesk form.
    const nearestInStock = dealersWithDistance.find(hasStock);
    if (nearestInStock) {
      resultsBottom.innerHTML = renderDealerCard(nearestInStock, {
        highlight: true,
        label: "Nearest Dealership With Stock"
      });
    }
  }
        return;
      } else {
        const topDealers = nearbyDealers.slice(0, 3);

        topDealers.forEach(dealer => {
          resultsBottom.innerHTML += renderDealerCard(dealer);
        });

        // If all of the top 3 dealers are sold out, also surface the nearest dealer that has stock
        const allSoldOut = topDealers.length > 0 && topDealers.every(dealer => !hasStock(dealer));
        if (allSoldOut) {
          const topDealerIds = new Set(topDealers.map(dealer => dealer.id));
          const nearestInStock = dealersWithDistance.find(
            dealer => !topDealerIds.has(dealer.id) && hasStock(dealer)
          );
          if (nearestInStock) {
            resultsBottom.innerHTML += renderDealerCard(nearestInStock, {
              highlight: true,
              label: "Nearest Dealership With Stock"
            });
          }
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      alert("An error occurred: " + error.message);
    }
  });
});

 document.addEventListener("change", function (e) {
  if (e.target && e.target.name === "id") {
    const selectedOption = e.target;
    const selectedVariantId = selectedOption.value;

    const product = window.Shopify?.product || window?.meta?.product;
    const variants = product?.variants;

    if (!variants) return;

    const selectedVariant = variants.find(v => v.id == selectedVariantId);
    if (selectedVariant) {
      const priceElement = document.getElementById("dynamicVariantPrice");
      if (priceElement) {
        const price = (selectedVariant.price / 100).toLocaleString(undefined, {
          style: "currency",
          currency: "USD"
        });
        priceElement.textContent = price;
      }
    }
  }
});